import { render, staticRenderFns } from "./ApiClientForm.vue?vue&type=template&id=009fa5e4&scoped=true&"
import script from "./ApiClientForm.vue?vue&type=script&lang=js&"
export * from "./ApiClientForm.vue?vue&type=script&lang=js&"
import style0 from "./ApiClientForm.vue?vue&type=style&index=0&id=009fa5e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009fa5e4",
  null
  
)

export default component.exports